(() => {
  const container = document.querySelector('[data-bella-search-return]');
  if (!container) return;
  const params = new URL(location.href).searchParams;
  const foodQuery = params.get('food_q');
  const globalQuery = params.get('search_q');
  if (!foodQuery && !globalQuery) return;
  const url = new URL(foodQuery ? container.dataset.foodUrl : container.dataset.searchUrl, location.origin);
  url.searchParams.set('q', foodQuery || globalQuery);
  if (!foodQuery) url.searchParams.set('type', 'product');
  const previous = params.get('search_return');
  if (!foodQuery && previous) {
    try {
      const previousURL = new URL(previous, location.origin);
      if (previousURL.origin === location.origin && previousURL.pathname === new URL(container.dataset.searchUrl, location.origin).pathname) {
        container.querySelector('a').href = previousURL.pathname + previousURL.search;
        container.hidden = false;
        return;
      }
    } catch {}
  }
  container.querySelector('a').href = url.pathname + url.search;
  container.hidden = false;
})();